import {IssueCreateConfigContextProvider, type IssueCreateConfigProviderProps} from './IssueCreateConfigContext'
import {IssueCreateDataContextProvider, type IssueCreateDataProviderProps} from './IssueCreateDataContext'

export type IssueCreateProviderProps = IssueCreateDataProviderProps & IssueCreateConfigProviderProps

export function IssueCreateContextProvider({children, ...props}: IssueCreateProviderProps) {
  return (
    <IssueCreateConfigContextProvider {...props}>
      <IssueCreateDataContextProvider {...props}>{children}</IssueCreateDataContextProvider>
    </IssueCreateConfigContextProvider>
  )
}
